import { CartItem } from "@/redux/slice/cart/types/CartItem";

export const getSkuQuantity = (sku: string, cartItems: CartItem[]) => {
  const findItem = cartItems.find((item) => item.sku === sku);

  return findItem ? findItem.quantity : 0;
};
